import { notification } from 'antd';
import { tiktokReviewNotificationCloseTimeCache } from 'services/cache';
import { tolgee } from 'services/i18n/tolgee';

const timeGap = 1000 * 60 * 60 * 4;
let _instance: number | null = null;

export const openTikTokReviewNotification = () => {
  const time = tiktokReviewNotificationCloseTimeCache.get<number>();

  if ((time && Date.now() - time < timeGap) || _instance) {
    return;
  }

  _instance = time;
  notification.warning({
    key: `${_instance}`,
    message: tolgee.t('TikTok获取评价数据异常'),
    description: tolgee.t('TT评价异常提示内容'),
    duration: 0,
    className: '!bg-[#FFFAF0]',
    onClose() {
      _instance = null;
      tiktokReviewNotificationCloseTimeCache.set(Date.now());
    },
  });
};

export const closeTikTokReviewNotification = () => {
  if (_instance) {
    notification.close(`${_instance}`);
    _instance = null;
  }
};
